<template>
  <v-card>
    <v-card-title>
      <span class="headline">Update Statuses</span>
      <div>This option will affect {{selectedCount}} items</div>
    </v-card-title>
    <v-card-text>
      <v-select
        label="Status"
        v-model="status"
        prepend-icon="info"
        :items="statusItems"
        type="text"
      ></v-select>
      <v-text-field prepend-icon="note" label="Notes" v-model="notes"></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" flat @click="close()">Cancel</v-btn>
      <v-btn color="red" flat @click="updateItems()" :loading="loading">Update Tipping Dockets</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import TippingService from "@/services/requests/tippingService";
import BuildTippingQuery from "../mixins/buildTippingQuery";
import StatusItems from "../mixins/statusItems";
import Store from "@/store/computed/storeHelpers";
export default {
  mixins: [BuildTippingQuery, StatusItems],
  data() {
    return {
      status: null,
      notes: "",
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    updateItems() {
      if (!this.status)
        return this.snack({ text: "Please select a status!", color: "yellow" });
      this.loading = true;
      var payload;
      this.selectedAll
        ? (payload = this.buildQuery())
        : (payload = { ids: this.selected.map(item => item.id) });
      payload.status = this.status;
      payload.notes = this.notes;
      TippingService.updateMultipleStatuses(payload)
        .then(result => {
          this.selected = [];
          this.selectedAll = false;
          this.$store.state.tipping.fetchTippingDockets = true;
          this.loading = false;
          this.snack({ text: result.data.message, color: "green" });
          this.close();
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.snack({ text: err.response.data.message, color: "red" });
        });
    }
  },
  computed: {
    selected: Store.getSet({ store: "tipping", prop: "selected" }),
    selectedAll: Store.getSet({ store: "tipping", prop: "selectedAll" })
  },
  props: {
    // selected: Array,
    // selectedAll: Boolean,
    selectedCount: Number
  }
};
</script>

<style>
</style>